var map = {
	"./Ambessa.png": 5333,
	"./Mel.png": 4723,
	"./NoBan.png": 4739,
	"styles/images/champions/icons/Ambessa.png": 5333,
	"styles/images/champions/icons/Mel.png": 4723,
	"styles/images/champions/icons/NoBan.png": 4739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1997;